<template>
<div id="okinavi">
	<div class="okinavi-back"></div>
	<header class="header">
		<div class="wrapper header-block">
			<a href="https://rirekisho.yagish.jp/" target="_blank" class="header-a">
				<h1><img src="/static/renew2_img/okinavi_img/logo-okinavi.png" alt="履歴書作成サービスヤギッシュ" class="header-logo"></h1>
			</a>
			<a href="https://rirekisho.yagish.jp/" target="_blank" class="link link-deco">履歴書をつくる</a>
		</div>
	</header>
	<div class="okinavi-wrap">
		<div class="first">

			<!--MV-->
			<section class="hero">
				<div class="hero-back">
					<div class="hero01">
						<img src="/static/renew2_img/okinavi_img/appeal-title.png" alt="国内No.1履歴書サービス" class="hero01-img">
						<p class="hero01-txt">中途、新卒、アルバイト、パート向け<br>多種のテンプレートご用意!</p>
					</div>
					<div class="hero02">
						<h2 class="hero02-h2">履歴書•職務経歴書を<br>
							<span class="hero02-h2span">ス</span>
							<span class="hero02-h2span hero02-h2span-ma">マ</span>
							<span class="hero02-h2span hero02-h2span-ho">ホ</span>
							<span class="hero02-h2span hero02-h2span-de hero02-h2small">で</span>
							<span class="hero02-h2span hero02-h2span-saku hero02-h2small">作</span>
							<span class="hero02-h2span hero02-h2span-sei hero02-h2small">成</span>
						</h2>
						<h3 class="hero02-h3">コンビニ印刷、PDFダウンロード<br>自分のメアドに送信可能</h3>
					</div>
					<div class="okinavi-cv">
						<img src="/static/renew2_img/okinavi_img/appeal-img.png" alt="今すぐはじめる" class="okinavi-cv-img">
						<div class="okinavi-cv-link">
							<a href="/" class="okinavi-cv-linka" target="_blank">今すぐはじめる</a>
						</div>
					</div>
				</div>
			</section>
		</div>
	
		<!--悩み-->
		<section class="second">
			<div class="second01">
				<h2 class="h2">履歴書作成について<br>みんな1人で悩んでいる•••</h2>
				<ul class="worries">
					<li class="worries-item worries-item01">履歴書・職務経歴書の<br>
						書き方、実は<br>
						よく分からない....</li>
					<li class="worries-item worries-item02">Word、Excel、<br>
						PC、プリンターの<br>
						用意が大変</li>
					<li class="worries-item worries-item03">履歴書・職務経歴書を<br>
						何枚も手書きするの<br>
						めんどくさい</li>
				</ul>
			</div>
		</section>
	
		<div class="seconddeco"></div>
	
		<!--アピール-->
		<section class="third">
			<div class="wrapper">
				<div class="third01">
					<p class="third01-title">国内No.1 履歴書サービス</p>
					<h2 class="third01-h2">ヤギッシュ<span>なら</span></h2>
				</div>
	
				<div class="third02">
					<div class="appeal-list">
						<img src="/static/renew2_img/okinavi_img/appeal-listimg01.png" alt="フォームに入力するだけで作成可能" class="appeal-listimg">
						<h3 class="appeal-listh3">フォームに入力するだけ<br>で作成可能</h3>
						<p class="appeal-listtxt">志望動機や自己PRの例文も多数用意！！<br>書き方を調べる必要なしでらくらく作成♪</p>
					</div>
					<div class="appeal-list">
						<img src="/static/renew2_img/okinavi_img/appeal-listimg02.png" alt="複数社への応募もラクラク" class="appeal-listimg">
						<h3 class="appeal-listh3 appeal-listh302">複数社への応募も<br>ラクラク</h3>
						<p class="appeal-listtxt">履歴書データが自動で保存されるから<br>書き直しの必要なし！</p>
					</div>
					<div class="appeal-list">
						<img src="/static/renew2_img/okinavi_img/appeal-listimg03.png" alt="スマホで作成後、好きな方法で履歴書をGET！" class="appeal-listimg">
						<h3 class="appeal-listh3 appeal-listh303">スマホで作成後、<br>好きな方法で履歴書をGET！</h3>
						<p class="appeal-listtxt">ダウンロード、メールで自分に送信、<br>コンビニで印刷、<br>しかも、応募先企業に直接送付も！</p>
					</div>
				</div>
			</div>
		</section>
	
		<!--ヤギオファー-->
		<section class="forth">
			<div class="forth01">
				<p class="forth01-p01">さらに</p>
				<p class="forth01-p02">履歴書を作成するだけで…</p>
				<h2 class="forth01-h2">好条件の企業から<br>
					<span>オファー</span>*がくる！
				</h2>
			</div>
			<div class="forth02">
				<div class="forth02-imgbox">
					<img src="/static/renew2_img/okinavi_img/forth02-img.png" alt="好条件の企業からオファーがくる！" class="forth02-img">
				</div>
				<p class="forth02-note">*ヤギッシュが提供するダイレクトリクルーティングサービス「yagioffer（ヤギオファー）」は、履歴書を作成して待つだけでオファーが届きます。</p>
			</div>
		</section>
	
		<!--CVボタン-->
		<section class="fifth">
			<div>
				<div class="okinavi-cv">
					<p class="okinavi-cv-txt">＼ 無料 ／</p>
					<a href="/" class="okinavi-cv-linka" target="_blank">今すぐはじめる</a>
				</div>
			</div>
		</section>
	
		<!--よくある質問-->
		<section class="sixth">
			<div class="sixth-back">
				<h2 class="sixth-h2">よくある質問</h2>
				<ul class="fqa-container">
					<li class="fqa-list">
						<h4 class="question">お金はかかるの？</h4>
						<p class="answer">基本無料ですが、一部、コンビニプリントなど有料サービスもあります。</p>
					</li>
					<li class="fqa-list">
						<h4 class="question">使い方がわからない！</h4>
						<p class="answer">具体的な操作方法は、<a href="/info" target="_blank">こちらのページ</a>をご覧ください。</p>
					</li>
				</ul>
			</div>
		</section>
	</div>

</div>
</template>

<style lang="scss" scoped>
	/*#okinavi .first{
		height: 100vh;
	}*/

	.okinavi-wrap{
		overflow-x: hidden;
	}

	#okinavi .header{
		-webkit-box-shadow: none;
		box-shadow: none;
	}

	#okinavi .okinavi-back{
		display: none;
	}

	#okinavi .header-block{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	#okinavi .link{
		position: relative;
		margin-right: 8px;
		background: #E3165C;
		padding: 5px 20px;
		border-radius: 50px;
		color: #fff;
		font-weight: bold;
	}

	#okinavi .link::before{
		position: absolute;
		content: "　　＼\A無料で\A　　／";
		white-space: pre;
		color: #E3165C;
		font-size: 12px;
		top: -12px;
    	left: -40px;
	}

	#okinavi .header-logo{
		width: 150px;
    	margin: 5px 0 5px;
	}

	#okinavi .hero {
		padding: 20px;
		background: url(/static/renew2_img/okinavi_img/back01.png) center center / cover no-repeat;
	}

	#okinavi .hero-back {
		background-color: rgba(239, 248, 248, 0.562);
		border-radius: 20px;
		/*height: calc(100vh - 50px);*/
	}

	#okinavi .hero01 {
		position: relative;
	}

	#okinavi .hero01-img {
		position: relative;
		width: 100%;
		top: -10px;
    	left: -10px;
	}

	#okinavi .hero01-txt {
		position: absolute;
		font-size: 12px;
		font-weight: bold;
		color: #004D40;
		bottom: 0px;
    	right: 5px;
	}

	#okinavi .hero02 {
		text-align: center;
		color: #004D40;
	}

	#okinavi .hero02-h2 {
		font-size: 30px;
		font-weight: bold;
		white-space: nowrap;
		margin: 30px 0 10px;
	}

	#okinavi .hero02-h2span {
		position: relative;
		display: inline-block;
		color: #fff;
		font-size: 40px;
		width: 80px;
		height: 80px;
		border-radius: 50%;
		background: #0F9934;
		text-align: center;
		line-height: 80px;
		right: -10px;
	}

	#okinavi .hero02-h2small {
		font-size: 24px;
		width: 40px;
		height: 40px;
		line-height: 40px;
	}
	#okinavi .hero02-h2span-ma{right: 10px;}
	#okinavi .hero02-h2span-ho{right: 30px;}
	#okinavi .hero02-h2span-de{right: 40px;}
	#okinavi .hero02-h2span-saku{right: 48px;}
	#okinavi .hero02-h2span-sei{right: 55px;}

	#okinavi .okinavi-cv {
		text-align: center;
	}

	#okinavi .hero-back .okinavi-cv{
		padding-bottom: 30px;
	}

	#okinavi .okinavi-cv-link {
		text-align: center;
	}

	#okinavi .hero-back .okinavi-cv-link{
		position: relative;
    	top: -15px;
	}

	#okinavi .okinavi-cv-img{
		position: relative;
		width: 230px;
    	height: auto;
		z-index: 5;
	}

	#okinavi .okinavi-cv-linka {
		display: inline-block;
		width: 80%;
		padding: 10px 20px;
		color: #fff;
		font-size: 28px;
		font-weight: bold;
		background: #E3165C;
		border-radius: 50px;
		border-bottom: 5px solid #8C103A;
	}

	#okinavi .second {
		text-align: center;
		background: #404040;
	}

	#okinavi .second01 {
		padding: 50px 0 200px;
		overflow: hidden;
	}

	.seconddeco {
		position: relative;
		height: 100px;
		background: linear-gradient(#404040, #EFF8F8 80%);
	}

	#okinavi .h2 {
		color: #fff;
		font-size: 24px;
		font-weight: bold;
	}

	#okinavi .worries {
		color: #004D40;
		font-weight: bold;
	}

	#okinavi .worries-item {
		position: relative;
		width: 250px;
		height: 150px;
		padding: 20px;
		font-size: 18px;
		z-index: 5;
	}

	#okinavi .worries-item01 {
		left: 0;
		top: 40px;
	}

	#okinavi .worries-item02 {
		right: -100px;
    	top: 65px;
	}

	#okinavi .worries-item03 {
		left: -10px;
    	top: 120px;
	}

	#okinavi .worries-item::after {
		position: absolute;
		content: "";
		background-image: url(/static/renew2_img/okinavi_img/worries-item01.svg);
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		width: 250px;
		height: 200px;
		left: 0;
		top: -30px;
		z-index: -1;
	}

	#okinavi .worries-item::before {
		position: absolute;
		content: "";
		background-image: url(/static/renew2_img/okinavi_img/worries-item01.svg);
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		width: 150px;
		height: 100px;
		right: -130px;
    	top: 50px;
		z-index: -1;
		opacity: 0.2;
	}

	#okinavi .worries-item02::after {
		background-image: url(/static/renew2_img/okinavi_img/worries-item02.svg);
		top: -10px;
	}

	#okinavi .worries-item02::before {
		background-image: url(/static/renew2_img/okinavi_img/worries-item02.svg);
		left: -150px;
	}

	#okinavi .worries-item03::after {
		background-image: url(/static/renew2_img/okinavi_img/worries-item03.svg);
		left: 0;
		top: -50px;
		width: 260px;
		height: 210px;
	}

	#okinavi .worries-item03::before {
		background-image: url(/static/renew2_img/okinavi_img/worries-item03.svg);
	}

	#okinavi .third {
		position: relative;
		background: #EFF8F8;
		padding: 100px 20px;
		text-align: center;
	}

	#okinavi .third::before {
		position: absolute;
		content: "";
		background-image: url(/static/renew2_img/okinavi_img/logo.png);
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;
		display: inline-block;
		width: 135px;
		height: 50px;
		z-index: 1;
		top: 30px;
		right: 30%;
		opacity: 0.2;
	}

	#okinavi .third01-title {
		position: relative;
		color: #fff;
		font-weight: bold;
		z-index: 1;
	}

	#okinavi .third01-title::after {
		position: absolute;
		content: url(/static/renew2_img/okinavi_img/third01-titledeco.png);
		top: -43px;
		right: 25%;
		z-index: -1;
		display: inline-block;
		width: 330px;
		height: 75px;
		transform: scale(0.5);
	}

	#okinavi .third01-h2 {
		color: #004D40;
		font-size: 30px;
		margin: 20px 10px 5px;
	}

	#okinavi .third01-h2 span {
		font-size: 20px;
	}

	#okinavi .appeal-list{
		margin-top: 50px;
	}

	#okinavi .appeal-listimg {
		position: relative;
		margin-bottom: 10px;
		width: 200px;
		z-index: 5;
	}

	#okinavi .appeal-listh3 {
		position: relative;
		margin-bottom: 10px;
		color: #404040;
		font-size: 24px;
		font-weight: bold;
	}

	#okinavi .appeal-listh3::before{
		position: absolute;
		content: "";
		background-image: url(/static/renew2_img/okinavi_img/appeal-listimgdeco.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		width: 160px;
		height: 150px;
		top: -150px;
    	right: 10px;
		z-index: 1;
	}

	#okinavi .appeal-listh302::before{
		top: -170px;
    	right: 160px;
	}

	#okinavi .appeal-listh303::before{
		display: none;
	}

	#okinavi .appeal-listtxt {
		margin-bottom: 50px;
	}

	#okinavi .appeal-listtxt:last-child {
		margin-bottom: 0;
	}

	#okinavi .forth {
		position: relative;
		padding: 50px 0;
		background: #fff;
	}

	#okinavi .forth::before,
	#okinavi .forth::after {
		position: absolute;
		display: inline-block;
		content: "";
		background-image: url(/static/renew2_img/okinavi_img/linedeco.png);
		background-repeat: repeat-x;
		background-size: 100%;
		width: 100%;
		height: 30px;
	}

	#okinavi .forth::before {
		top: -15px;
	}

	#okinavi .forth::after {
		bottom: -20px;
	}

	#okinavi .forth01 {
		text-align: center;
		font-weight: bold;
	}

	#okinavi .forth01-p01 {
		position: relative;
		color: #289CA6;
		font-size: 20px;
	}

	#okinavi .forth01-p01::after {
		position: absolute;
		content: "";
		background-image: url(/static/renew2_img/okinavi_img/forth01deco.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		width: 30px;
		height: 46px;
		top: -10px;
	}

	#okinavi .forth01-p02 {
		color: #004D40;
		font-size: 24px;
		margin-bottom: 10px;
	}

	#okinavi .forth01-h2 {
		color: #404040;
		font-size: 30px;
		line-height: 1.2;
	}

	#okinavi .forth01-h2 span {
		color: #289CA6;
	}

	#okinavi .forth02-imgbox {
		position: relative;
		text-align: center;
		padding: 30px;
		margin: 20px 30px 10px;
		background: #FFFFE8;
		border-radius: 10px;
	}

	#okinavi .forth02-imgbox::after {
		position: absolute;
		content: "";
		background-image: url(/static/renew2_img/okinavi_img/forth02-imgdeco.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		width: 80px;
		height: 86px;
		bottom: 0;
		left: -20px;
	}

	#okinavi .forth02-note {
		font-size: 12px;
		padding: 0 10px;
	}

	#okinavi .fifth {
		background: #fff;
		padding: 50px 0;
	}

	#okinavi .sixth {
		background-image: url(/static/renew2_img/okinavi_img/back02.jpeg);
		background-color: rgba(255, 255, 255, 0.8);
		background-blend-mode: lighten;
		padding: 50px 10px;
	}

	#okinavi .sixth-h2 {
		font-size: 24px;
		color: #404040;
		text-align: center;
		margin-bottom: 20px;
	}

	#okinavi .question:before {
		position: relative;
		display: inline-block;
		content: "Q";
		background-color: #004D40;
		border-radius: 50px;
		color: #fff;
		font-weight: bold;
		text-align: center;
		line-height: 30px;
		top: -2px;
		left: -10px;
		width: 30px;
		height: 30px;
		opacity: 1;
	}

	#okinavi .okinavi-cv-txt {
		font-size: 24px;
		font-weight: bold;
		color: #E3165C;
	}

	#okinavi .fqa-list {
		margin-bottom: 20px;
	}

	#okinavi .question {
		margin-left: 15px;
		margin-bottom: 10px;
	}


	@media screen and (min-width: 641px) {
		.okinavi-wrap{
			max-width: 375px;
			margin: 0 auto;
		}

		#okinavi .hero{
			background: none;
		}

		#okinavi .okinavi-back{
			position: fixed;
			display: block;
			background: url(/static/renew2_img/okinavi_img/back01.png) center center / cover no-repeat;
			z-index: -1;
			top: 0;
			left: 0;
			height: 100vh;
			width: 100vw;
		}
	}
	#okinavi .link:hover{
		text-decoration: none;
		border: 2px solid #e3165c;
		background: #fff;
		color: #e3165c;
	}

	#okinavi .okinavi-cv-linka:hover{
		position: relative;
		text-decoration: none;
		border-bottom: 0;
		top: 5px;
		opacity: 1;
	}
</style>
<script>
export default {
  data: function () {
    return {
    }
  },
  computed: {},
  methods: {
  },
  watch: {},
  mounted: function () {

    console.error(this.$route.name)
    console.error("this.$route.path")
  }
}
</script>